// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__5mz0n","rootCenter":"LoadMoreObserver_rootCenter__1NvFg","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1cu8X"};